var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4.75C9 4.33579 8.66421 4 8.25 4H5C3.8954 4 3 4.8954 3 6L3 18C3 19.1046 3.8954 20 5 20H8.25C8.66421 20 9 19.6642 9 19.25C9 18.8358 8.66421 18.5 8.25 18.5H5.4856C4.93331 18.5 4.4856 18.0523 4.4856 17.5L4.4856 6.5C4.4856 5.94771 4.93331 5.5 5.4856 5.5H8.25C8.66421 5.5 9 5.16421 9 4.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74996 12.5833H18.8418L15.7542 15.6709C15.5264 15.8987 15.5264 16.268 15.7542 16.4957C15.982 16.7235 16.3514 16.7235 16.5792 16.4957L20.6625 12.4124C20.8903 12.1846 20.8903 11.8152 20.6625 11.5876L16.5792 7.50425C16.4653 7.39035 16.316 7.33333 16.1666 7.33333C16.0174 7.33333 15.8681 7.39035 15.7542 7.50425C15.5264 7.73204 15.5264 8.10143 15.7542 8.32908L18.8418 11.4167H9.74996C9.42781 11.4167 9.16663 11.6778 9.16663 12C9.16663 12.3221 9.42781 12.5833 9.74996 12.5833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.2c73139a5f80e8c1e386ec242223544e.svg";
export { ForwardRef as ReactComponent };